<template>
    <ElementLayout :parent="parent" :element="element">
            
        <div style="height:24px;" class="element-label">
            {{label}}
            <v-progress-circular style="margin-left:10px" v-show="uploading" size="20" width="2" indeterminate color="primary"></v-progress-circular>
        </div>


            <croppa v-model="imageObject" style="border:solid 2px #bbb;border-radius:0px"
                :width="width"
                :height="height"
                :quality="1"
                :placeholder="placeholder"
                :placeholder-font-size="14"
                :file-size-limit="100000"
                @file-size-exceed="fileSizeExceeded"
                placeholder-color="#999"
                :disabled="false"
                :prevent-white-space="true"
                canvas-color="white"
                :show-remove-button="true"
                :remove-button-size="20"
                :initial-image="element.value"
                @zoom="imageChanged"
                @move="imageChanged"
                @file-choose="imageChanged"
                @image-remove="imageRemoved">
                
                <!-- <img crossOrigin="Anonymous" :src="element.value" slot="initial" /> -->
            </croppa>
        <!-- <v-text-field v-model="element.value" @change="fieldChanged" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" /> -->
        <div slot="right">
            <!-- <SplitButton xoutline  :menus="[{text:'Remove Image'}]" class="full-width" @click="changeButtonClick">Change</SplitButton> -->
        </div>
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import {differenceInSeconds} from 'date-fns'
import Firestore from '@/data/Firestore'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import AlertHelpers from '../../helpers/AlertHelpers'
import SplitButton from '../../ui-elements/SplitButton'


export default {
    data() {
        return {
            imageObject: {},
            uploading: false,
            uploaded: false,
            dirty: false,
        }
    },

    components: {
        ElementLayout,
        SplitButton,
    },
    
    props: {
        element: Object,
        parent: Object,
        width: {
            type: Number,
            default: 50,
        },
        height: {
            type: Number,
            default: 50,
        }
    },

    computed: {
        storagePath() {
            return 'teams/' +  Firestore.shortPath(this.element._path) + '/' + this.element.rowId
        },
        displayImage() {
            if(this.element.value && this.element.value.indexOf('randomuser') < 0 && this.element.value.indexOf('transparent') < 0) {
                return this.element.value
            }

            return ''
        },
        placeholder() {
            if(this.width < 60)
                return '[?]'
            return 'Choose...'
        },

        label() {
            if(this.uploading)
                return 'Uploading...'
            if(this.uploaded)
                return 'Zoom and Move to Center'
            return this.element.title
        }

    },

    methods: {

        fieldChanged(newVal) {
            this.$emit('change', {value: newVal, previousValue: this.originalValue})
            this.originalValue = newVal
        },
        fileSizeExceeded() {
            this.dirty = false
            AlertHelpers.showAlert('File is too big')
        },
        imageChanged() {
            this.dirty = true
            this.uploaded = false
            setTimeout( ()=> {
                this.upload()
            },500)
        },

        imageRemoved() {
            console.log('image removed')
            this.element.value = ''
        },

        upload() {
            if(this.uploading) {
                console.log('Not uploading...upload in progress')
                return
            }

            if(!this.dirty) {
                console.log('Upload cancelled by system')
                return
            }

            this.dirty = false
            
            this.uploading = true
            this.imageObject.generateBlob((blob) => {
                    let fileName = this.imageObject
                    firebase.storage().ref(this.storagePath + '/' + this.element.name + '.jpg').put(blob)
                    .then(fileData => {
                        fileData.ref.getDownloadURL().then(url => {
                            console.log('Finished uploading', url)
                            this.element.value = url
                            this.uploading = false
                            this.uploaded = true
                            if(this.dirty)
                                this.upload()
                        })
                        
                    })

            },'image/jpeg', 0.5)
        }
    },

    created() {
        
    },

    watch: {
 
    }
}
</script>

<style scoped>

.croppa-container {
   background-color: white;
   border: 2px solid #bbb;
   border-radius: 8px;
 }
   
</style>




// WEBPACK FOOTER //
// ImageControl.vue?1bb884c5